<template>
  <b-modal
    id="viewfeedbackTP"
    size="lg"
    centered
    hide-footer
    hide-header
    class="p-0"
    no-close-on-backdrop
    :visible="showModal"
    @hidden="closemodal()"
  >
    <div class="cs-modal-header">
      <div>Feedback Form</div>
      <div @click="closemodal()">
        <img
          class="rotate-on-hover"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt=""
        />
      </div>
    </div>

    <div class="vc-body">
      <div
        v-for="(feedback, index) in feedbacks"
        :key="index"
        class="viewc-card-container width-529 mt-3"
      >
        <div
          class="padding-6-19 pointer"
          @click="toggleCollapse(feedback)"
          :class="
            feedback.interviewID === selectedFeedback.interviewID
              ? 'viewc-open-card'
              : 'viewc-close-card'
          "
        >
          <div>
            <div class="vc-black-txt text-capitalize">
              {{ feedback.interviewRound.name }}
            </div>
            <div
              class="vs-notinterested-2"
              v-if="
                feedback.feedBackForm.panelName &&
                feedback.feedBackForm.panelName != undefined &&
                feedback.feedBackForm.panelName != 'undefined'
              "
            >
              {{
                feedback.feedBackForm.recommendation == "NI"
                  ? "Recruiter"
                  : "Panelist"
              }}: {{ feedback.feedBackForm.panelName }}
            </div>
            <div
              class="vs-notinterested-2"
              v-else-if="feedback.feedBackForm.createdFor"
            >
              {{
                feedback.feedBackForm.recommendation == "NI"
                  ? "Recruiter"
                  : "Panelist"
              }}:{{ feedback.feedBackForm.createdFor }}
            </div>
            <div class="vs-notinterested-2" v-else>
              {{
                feedback.feedBackForm.recommendation == "NI"
                  ? "Recruiter"
                  : "Panelist"
              }}
              : -
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="vc-darkgrey-txt mr-3">
              {{ feedback.feedBackForm.createdAt | formatdate }}
            </div>
            <img
              v-if="
                feedback.feedBackForm &&
                feedback.feedBackForm.recommendation != 'NI' &&
                (feedback.feedBackForm.customFeedback == undefined ||
                  Object.keys(feedback.feedBackForm.customFeedback).length == 0)
              "
              @click.stop="
                $emit(
                  'download-feedback',
                  feedback.feedBackForm.panelFeedbackForm
                )
              "
              class="pointer"
              v-b-tooltip.hover.bottom="'Download Feedback'"
              src="../../../assets/talentpool/download.svg"
              alt=""
            />
            <template v-else>
              <img
                v-if="feedback.interviewID != selectedFeedback.interviewID"
                class="pointer"
                src="../../../assets/talentpool/bluedownarrow.svg"
                alt=""
              />
              <img
                v-else
                class="pointer"
                src="../../../assets/talentpool/blueuparrow.svg"
                alt=""
              />
            </template>
          </div>
        </div>
        <b-collapse
          :id="feedback.interviewID"
          :visible="feedback.interviewID == selectedFeedback.interviewID"
        >
          <div class="pl-3 pr-3">
            <b-row class="mt-3">
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-center
                    h-100
                  "
                >
                  Candidate Name
                </div>
              </b-col>
              <b-col cols="8">
                <div class="viewcand-field d-flex align-items-center">
                  {{ basicInfo.name }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-center
                    h-100
                  "
                >
                  Evaluation Date
                </div>
              </b-col>
              <b-col cols="8">
                <div
                  class="viewcand-field d-flex align-items-center"
                  v-if="!basicInfo.evalDate"
                >
                  -
                </div>
                <div class="viewcand-field d-flex align-items-center">
                  {{ basicInfo.evalDate | formatdate }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-center
                    h-100
                  "
                >
                  {{
                    feedback.feedBackForm.recommendation == "NI"
                      ? "Recruiter"
                      : "Panelist"
                  }}
                </div>
              </b-col>
              <b-col cols="8">
                <div
                  class="viewcand-field d-flex align-items-center"
                  v-if="
                    feedback.feedBackForm.panelName &&
                    feedback.feedBackForm.panelName != undefined &&
                    feedback.feedBackForm.panelName != 'undefined'
                  "
                >
                  {{ feedback.feedBackForm.panelName }}
                </div>
                <div
                  class="viewcand-field d-flex align-items-center"
                  v-else-if="feedback.feedBackForm.createdFor"
                >
                  {{ feedback.feedBackForm.createdFor }}
                </div>
                <div class="viewcand-field d-flex align-items-center" v-else>
                  -
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-center
                    h-100
                  "
                >
                  Mode Of Interview
                </div>
              </b-col>
              <b-col cols="8">
                <div class="viewcand-field d-flex align-items-center">
                  {{
                    basicInfo.modeOfInterview == "f2f"
                      ? "Face to Face"
                      : "Assessment"
                  }}
                </div>
              </b-col>
            </b-row>
            <b-row
              class="mt-3"
              :class="
                skills.length == 0 && basicInfo.action != 'NI' ? 'mb-3' : ''
              "
            >
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-center
                    h-100
                  "
                >
                  Action
                </div>
              </b-col>
              <b-col cols="8">
                <div class="viewcand-field d-flex align-items-center">
                  {{
                    basicInfo.action == "R"
                      ? "Rejected"
                      : basicInfo.action == "S" || basicInfo.action == "F"
                      ? "Selected"
                      : basicInfo.action == "NI"
                      ? "Not Interested"
                      : basicInfo.action == "H"
                      ? "On Hold"
                      : ""
                  }}
                </div>
              </b-col>
            </b-row>
            <b-row
              class="mt-3"
              v-if="basicInfo.action == 'NI' && basicInfo.remarks"
              :class="skills.length == 0 ? 'mb-3' : ''"
            >
              <b-col cols="4">
                <div
                  class="
                    pff-add-left-main-headings
                    d-flex
                    align-items-center
                    h-100
                  "
                >
                  Remarks
                </div>
              </b-col>
              <b-col cols="8">
                <div class="viewcand-field d-flex align-items-center">
                  {{ basicInfo.remarks }}
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  v-if="
                    basicInfo.modeOfInterview !== 'f2f' &&
                    basicInfo.feedback &&
                    basicInfo.feedback.status === 2 &&
                    basicInfo.feedback.evaluationStatus
                  "
                  class="mt-3 newJD-int-container p-0"
                >
                  <div class="newJD-int-container-selected pointer">
                    <div class="newJD-int-mainhead">Assessment</div>
                  </div>
                  <div class="p-3">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="newCand-viewFdbck-font">
                        Total Marks :
                        {{ basicInfo.feedback.marks.marksScored }}/{{
                          basicInfo.feedback.marks.totalMarks
                        }}
                      </div>
                      <div class="newCand-viewFdbck-font">
                        Passing Percentage (%) :
                        {{
                          basicInfo.feedback.passingStatus.passingPercentage
                        }}/100
                      </div>
                    </div>

                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        mt-2
                        w-100
                      "
                    >
                      <div style="width: 90%">
                        <div class="newCand-viewFdbck-head">Sections</div>
                        <div
                          v-for="(section, index) in basicInfo.feedback.marks
                            .sectionMarks"
                          :key="index"
                          class="mt-2 newCand-viewFdbck-subhead"
                        >
                          {{ section.sectionName }}
                        </div>
                      </div>
                      <div style="width: 10%">
                        <div class="newCand-viewFdbck-head">Marks</div>
                        <div
                          v-for="(section, index) in basicInfo.feedback.marks
                            .sectionMarks"
                          :key="index"
                          class="mt-2 newCand-viewFdbck-font"
                        >
                          {{ section.sectionMarksScored }}/{{
                            section.sectionMarksTotal
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>

            <div
              class="mt-3 newInt-inner-containers"
              v-for="(skill, index) in skills"
              :key="index + 'sk'"
              :class="index == skills.length - 1 ? 'mb-3' : ''"
            >
              <!-- :style="input.name.length > 30 ? 'width: 70%' : ''" -->
              <div>
                <div class="newInt-inner-containers-head text-truncate">
                  {{ skill.name }}
                </div>

                <div v-if="skill.markingType == 'rating'" class="mt-2 d-flex">
                  <div class="mt-2 newInt-inner-containers-subhead">Rating</div>
                  <div>
                    <b-form-rating
                      variant="primary"
                      class="mb-2 newInt-rating p-0 w-25 ml-2"
                      disabled
                      v-model="skill.mark"
                    ></b-form-rating>
                  </div>
                </div>

                <div v-if="skill.markingType == 'score'" class="mt-2">
                  <div class="topDiv d-flex align-items-center">
                    <div class="newInt-inner-containers-subhead">Score</div>
                    <div style="width: 8%" class="ml-2">
                      <b-form-input
                        style="height: 30px"
                        class="feed-input-score w-100"
                        disabled
                        type="number"
                        v-model="skill.mark"
                      >
                      </b-form-input>
                    </div>
                    <div class="ml-1 newInt-inner-containers-subhead">
                      Out of 10
                    </div>
                  </div>
                </div>

                <div v-if="skill.commentMode" class="mt-2">
                  <div class="topDiv">
                    <div>
                      <label class="newInt-inner-containers-subhead"
                        >Comments</label
                      >
                    </div>
                    <div class="mt-1">
                      <b-form-textarea
                        class="newInt-previewInputField"
                        disabled
                        rows="3"
                        max-rows="4"
                        v-model="skill.comments"
                      >
                      </b-form-textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="newInt-inner-containers mb-3"
              v-if="
                screenshot.available &&
                screenshot.screenShotMedia != '' &&
                screenshot.screenShotMedia != undefined
              "
            >
              <div class="d-flex align-items-center">
                <div>
                  <img
                    src="../../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                    alt=""
                  />
                </div>
                <div class="newInt-sc-font ml-3">Candidate Screenshot</div>
              </div>

              <!-- <div
                v-if="screenshot.available"
                class="
                  mt-3
                  newInt-previewInputField-sc
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <div class="sc-font">No Screenshot Required</div>
              </div> -->
              <div
                class="
                  mt-3
                  newInt-previewInputField-sc
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <div class="sc-font">Screenshot will be shown here</div>
                <img src="" alt="" />
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="d-flex align-items-center">
      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          w-100
          border-top
          bluebtn
          pt-3
          pb-3
          pl-4
          pr-4
        "
      >
        <b-button class="acs-cancelBtn-modal" @click="closemodal()"
          >Close</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      selectedFeedback: {},
      basicInfo: {},
      screenshot: {},
      skills: [],
      loopvar: 4,
    };
  },
  props: {
    showModal: Boolean,
    feedbacks: Array,
    candidateData: Object,
  },
  filters: {
    formatdate(data) {
      if (data) {
        const date = new Date(data);
        let month = date.getMonth() + 1;
        if (month.toString().length < 2) month = "0" + month;
        return `${date.getDate()}-${month}-${date.getFullYear()}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    toggleCollapse(feedback) {
      if (this.selectedFeedback?.interviewID === feedback.interviewID) {
        this.selectedFeedback = {};
        this.basicInfo = {};
        this.skills = [];
      } else {
        this.selectedFeedback = feedback;
        this.basicInfo["name"] = this.candidateData.name;
        this.basicInfo["evalDate"] =
          this.selectedFeedback.feedBackForm.createdAt;
        this.basicInfo["panel"] = this.selectedFeedback.feedBackForm.panelName;
        this.basicInfo["modeOfInterview"] =
          this.selectedFeedback.interviewRound.type;
        this.basicInfo["action"] =
          this.selectedFeedback.feedBackForm.recommendation;
        this.basicInfo["remarks"] =
          this.selectedFeedback.feedBackForm.recruiterRemarks;
        this.basicInfo["feedback"] = this.selectedFeedback.assessmentResponse;
        this.skills = this.selectedFeedback.feedBackForm.customFeedback.skills
          ? this.selectedFeedback.feedBackForm.customFeedback.skills
          : [];
        this.screenshot.available =
          this.selectedFeedback.feedBackForm.customFeedback.screenshot;
        this.screenshot.screenShotMedia =
          this.selectedFeedback.feedBackForm.customFeedback.screenShotMedia;
      }
    },
    closemodal() {
      this.$emit("closeViewIcon");
    },
  },
};
</script>

<style></style>
